import setErrorRes from './setErrorRes';

export default function catchAsync(asyncFn) {
  return async (data, thunkAPI) => {
    try {
      return await asyncFn(data, thunkAPI);
    } catch (error) {
      // Перевіряємо статус помилки
      // if (error?.response?.status === 401) {
      //   window.location.reload(); // Перезавантажуємо сторінку
      // }
      // Викликаємо setErrorRes для обробки помилки
      return thunkAPI.rejectWithValue(setErrorRes(error));
    }
  };
}
